import type { Requester } from '@labeling/globals';
import { useUserStore } from '@/stores/user-store';
import { ROLE_ORDER } from './role-utils';

export const useRoleAssumption = () => {
  const availableRoles = useUserStore((s) => s.availableRoles);
  const currentRoleType = useUserStore((s) => s.user.type);
  const setAssumedRole = useUserStore((s) => s.setAssumedRole);

  const sortedRoles = [...availableRoles].sort(
    (a, b) => ROLE_ORDER.indexOf(a.type) - ROLE_ORDER.indexOf(b.type)
  );

  const selectRole = (type: Requester['type']) => {
    if (type === currentRoleType) return;
    const role = availableRoles.find((r) => r.type === type);
    if (role) setAssumedRole(role);
  };

  return {
    hasMultipleRoles: availableRoles.length > 1,
    sortedRoles,
    currentRoleType,
    selectRole,
  };
};
